// extracted by mini-css-extract-plugin
export default {"path_info":"PathsInfo_path_info__FIwSE","buttons":"PathsInfo_buttons__9Wdp+","active":"PathsInfo_active__qGQ3s","path_info__mobile":"PathsInfo_path_info__mobile__btKK1"};